export interface StepProps<TValues> {
  onSubmit: (options?: Partial<TValues>) => void;
  onPreviousClick?: () => void;
  onFieldChange?: (fieldName: keyof TValues, value: unknown) => void;
  onFieldFocus?: (fieldName: keyof TValues) => void;
  values?: TValues;
  totalSteps: number;
  currentStep: number;
}

export enum PrefillStatus {
  Empty = 'Empty',
  Synchronous = 'Synchronous',
  Asynchronous = 'Asynchronous',
}
